var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanTitleBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 116,
    viewBox: "0 0 85 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.2227 0H0V116L78.0578 38.4017C92.2784 24.2557 82.2681 0 62.2227 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2227 115.988H0V0L78.0578 77.6107C92.2784 91.7195 82.2681 115.988 62.2227 115.988Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2227 0H0V116L78.0578 38.4017C92.2784 24.2557 82.2681 0 62.2227 0Z",
    fill: "#5D92CD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2227 115.988H0V0L78.0578 77.6107C92.2784 91.7195 82.2681 115.988 62.2227 115.988Z",
    fill: "#E62867"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanTitleBrand);
export default __webpack_public_path__ + "static/media/planTitleBrand.ede8bfd0f97ed1e8a2d4997bce1d5f52.svg";
export { ForwardRef as ReactComponent };